import { useIsNationalSite } from "../stores/hooks/useIsNationalSite";
import {
  NationalTiresizeResultsRoute,
  NationalVehicleResultsRoute,
} from "./NationalRoutes";
import { getDealerBasePath } from "./getDealerBasePath";
import { getNationalBasePath } from "./getNationalBasePath";
import { useSomeRoutes } from "./useSomeRoutes";

export const useHomeLink = (): string => {
  const isNationalLanding = useSomeRoutes(
    NationalVehicleResultsRoute,
    NationalTiresizeResultsRoute
  );

  const isNational = useIsNationalSite();

  const nationalBasePath = getNationalBasePath();

  if (isNationalLanding) {
    return `${nationalBasePath}/landingpage`;
  }

  if (isNational) {
    return nationalBasePath;
  }

  return getDealerBasePath();
};
